import createAction from '@clearscore-group/lib.helpers.create-action';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';
var SET_CONFIG = 'CS/SET_CONFIG';
var CLEAR_CONFIG = 'CS/CLEAR_CONFIG';
var typesImport = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SET_CONFIG: SET_CONFIG,
  CLEAR_CONFIG: CLEAR_CONFIG
});

// SET_CONFIG
var setConfig = function setConfig(configData) {
  return createAction(SET_CONFIG, configData);
};

// CLEAR_CONFIG
var clearConfig = function clearConfig() {
  return createAction(CLEAR_CONFIG, {});
};
var actionsImport = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setConfig: setConfig,
  clearConfig: clearConfig
});
var initialState = {};

// eslint-disable-next-line import/prefer-default-export
var configReducer = function configReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
    payload = action.payload;
  switch (type) {
    case SET_CONFIG:
      return _objectSpread(_objectSpread({}, state), payload);
    case CLEAR_CONFIG:
      return {};
    default:
      return state;
  }
};
var reducersImport = /*#__PURE__*/Object.freeze({
  __proto__: null,
  configReducer: configReducer
});
var getMarketingRevisionVersion = function getMarketingRevisionVersion(state) {
  return resolveProp('config.MKT_PREF_VERSION', state);
};
var getTncVersion = function getTncVersion(state) {
  return parseInt(resolveProp('config.TERMSREVISIONNUMBER', state), 10);
};
var getImageCdn = function getImageCdn(state) {
  return resolveProp('config.IMAGECDN', state);
};
var getApiDomain = function getApiDomain(state) {
  return resolveProp('config.API_DOMAIN', state);
};
var getSegment = function getSegment(state) {
  return resolveProp('config.SEGMENT', state);
};
var getTrackingApi = function getTrackingApi(state) {
  return resolveProp('config.API_TRACKING', state);
};
var getMediaUrl = function getMediaUrl(state) {
  return resolveProp('config.MEDIA_URL', state);
};
var getImdb = function getImdb(state) {
  return {
    key: getSegment(state),
    url: getTrackingApi(state)
  };
};
var getEvents = function getEvents(state) {
  return {
    imdb: getImdb(state)
  };
};

// selector
var config_selectors = createSelector(getMarketingRevisionVersion, getTncVersion, getImageCdn, getApiDomain, getEvents, getImdb, getMediaUrl, function (marketingRevisionVersion, tncVersion, imageCdn, apiDomain, events, imdb, mediaUrl) {
  return {
    marketingRevisionVersion: marketingRevisionVersion,
    tncVersion: tncVersion,
    imageCdn: imageCdn,
    apiDomain: apiDomain,
    events: events,
    imdb: imdb,
    mediaUrl: mediaUrl
  };
});
var selectorsImport = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': config_selectors
});
var actions = actionsImport;
var reducers = reducersImport;
var selectors = selectorsImport;
var types = typesImport;
export { actions, reducers, selectors, types };